module.exports = __webpack_public_path__ + "img/search-icon.fdea14f2.svg";